var exports = {
  "u": "xcc377c0b--8c8df6--toggle-btn",
  "q": "xcc377c0b--8c8df6--toggle-btn--close",
};

module.exports = exports;
